import { useState, useEffect, useCallback } from 'react';
import ReportUI from './components/ReportUI';
import moment from 'moment';
import { useSelector, useDispatch } from "react-redux";
import { message } from 'antd';
import { getDriverLogsThunk, selectDriverLogsState } from '../../redux/slices/driverLogs';

const Main = () => {
    const [dates, handleDates] = useState([moment().subtract(7, 'days'), moment()]);
    const [filters, setFilters] = useState({});
    const [loading, handleLoading] = useState(true);
    const { logs, total, page, limit } = useSelector(selectDriverLogsState);
    const dispatch = useDispatch();

    const fetchLogs = useCallback(async (currentDates, currentFilters, currentPage, currentLimit) => {
        handleLoading(true);
        const config = {
            page: currentPage || 1,
            limit: currentLimit || 20,
            date_start: currentDates[0] ? currentDates[0].format("YYYY-MM-DD HH:mm:ss") : undefined,
            date_end: currentDates[1] ? currentDates[1].format("YYYY-MM-DD HH:mm:ss") : undefined,
            ...currentFilters
        };

        const response = await dispatch(getDriverLogsThunk(config));
        if (response.status !== "success") {
            message.error("¡Hubo un problema cargando los logs!");
        }
        handleLoading(false);
    }, [dispatch]);

    useEffect(() => {
        fetchLogs(dates, filters, 1, 20);
    }, [dates, fetchLogs, filters]);

    const onChangeDates = (datesInputs) => {
        // antd RangePicker can return null if cleared
        const newDates = datesInputs || [null, null];
        handleDates(newDates);
        fetchLogs(newDates, filters, 1, limit);
    }

    const onTableChange = (pagination, activeFilters = filters) => {
        setFilters(activeFilters);
        fetchLogs(dates, activeFilters, pagination.current, pagination.pageSize);
    };

    return (
        <ReportUI
            onChangeDates={onChangeDates}
            onTableChange={onTableChange}
            loading={loading}
            logs={logs}
            dates={dates}
            total={total}
            page={page}
            limit={limit}
        />
    );
};

export default Main;
